import { render } from "./SliderItem.vue?vue&type=template&id=b8445f74"
import script from "./SliderItem.vue?vue&type=script&lang=ts"
export * from "./SliderItem.vue?vue&type=script&lang=ts"
script.render = render

export default script